/**
 * 어두운 화면(시작 · 골목 · 작별)이 떠 있는 동안 시스템 바 자리를 그 화면 색으로(DEV-13 0 · N-030).
 *
 * 앱의 웹뷰는 상태바 · 아래 바 사이에 들어가서 바 자리엔 창 바탕(크림)이 보여, 어두운 화면 위아래에 밝은 띠가 섰습니다.
 * 이 화면 동안만 창 바탕(AppChrome 플러그인, android AppChromePlugin.java) · body 를 먹색으로, 바 아이콘을 밝게 둡니다.
 * 웹에서는 body 바탕만 바뀌고 플러그인은 부르지 않습니다.
 */
import { useEffect } from 'react';
import { Capacitor, registerPlugin, SystemBars, SystemBarsStyle } from '@capacitor/core';

const AppChrome = registerPlugin('AppChrome');

// style.css 의 --color-text-primary · --color-bg 와 같은 색
const DARK = '#26231F';
const LIGHT = '#F6F1E7';

let holders = 0;

function setChrome(dark) {
    if (!Capacitor.isNativePlatform()) {
        return;
    }
    const fail = (error) => console.error('[bars] 바 색을 바꾸지 못함', error?.name);
    SystemBars.setStyle({ style: dark ? SystemBarsStyle.Dark : SystemBarsStyle.Light }).catch(fail);
    // 예전 껍데기(플러그인 없음)면 조용히 실패
    AppChrome.setBackground({ color: dark ? DARK : LIGHT }).catch(fail);
}

export function useDarkChrome() {
    useEffect(() => {
        holders += 1;
        document.body.dataset.chrome = 'dark';
        setChrome(true);
        return () => {
            holders -= 1;
            // 어두운 화면끼리 넘어갈 때(골목 → 카드) 밝게 깜빡이지 않게, 마지막 하나가 내려갈 때만 되돌림
            if (holders === 0) {
                delete document.body.dataset.chrome;
                setChrome(false);
            }
        };
    }, []);
}
